import {
  DEFAULT_MODEL_BY_PROVIDER,
  MODELS_BY_PROVIDER,
  type ModelPreferenceDefaults,
  type ModelProvider,
  type ProviderModel,
  resolveLegacyModel,
} from "@/types/modelPreferences.ts";

/** Keeps saved selections and cohort defaults on the model the backend will run. */
export function pickerModel(
  provider: ModelProvider,
  savedModel: ProviderModel | undefined,
  defaults: ModelPreferenceDefaults,
): ProviderModel {
  const allowedModels = MODELS_BY_PROVIDER[provider];
  if (savedModel !== undefined) {
    const model = resolveLegacyModel(savedModel);
    if (allowedModels.includes(model)) return model;
  }
  if (provider === defaults.provider) {
    const model = resolveLegacyModel(defaults.model);
    if (allowedModels.includes(model)) return model;
  }
  return DEFAULT_MODEL_BY_PROVIDER[provider];
}
